var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKshemaLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#878282",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3571 12.146L22.6508 13.7714L22.2271 14.7608L21.1677 17.2343C20.6027 18.5064 19.8965 19.2131 18.2015 19.2131H16.789L15.9415 19.0718L15.0234 18.0824L14.8821 17.5877L14.5996 15.8916L14.8821 16.1743V16.3156C14.8821 16.7396 15.094 17.1637 15.3765 17.4463C15.659 17.729 16.0827 17.941 16.5771 17.941C17.2833 17.941 17.8483 17.517 18.1308 16.9516V16.881L18.3427 16.3156L19.2608 14.1248C19.8965 12.57 20.6027 12.2167 22.2271 12.2167H23.3571V12.146Z",
    fill: "#5C79AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3178 12.146L22.3291 14.4075C22.8941 13.2061 23.1766 12.57 23.7416 12.146H23.3178Z",
    fill: "#5C79AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.783 24.7279L23.2181 23.8092L21.4524 20.5583C20.9581 19.7102 20.1106 19.1449 19.1218 19.1449H17.3562H17.2856C16.5793 19.1449 15.7318 18.7915 15.3787 18.2968L15.3081 18.2261L15.2375 18.1555C15.1669 18.0141 15.0962 17.9435 15.0256 17.8021C15.0256 17.8021 15.0256 17.7314 14.955 17.7314V17.6608C14.955 17.5901 14.955 17.5901 14.955 17.5194V17.4488V17.3781C14.955 17.3074 14.955 17.2367 14.955 17.1661C14.955 17.0954 14.955 17.0954 14.955 17.0247V7.4841C14.955 6.63604 14.3194 6 13.4719 6H12.0594H11C11.6356 6.70671 11.7062 6.9894 11.7062 8.26148V16.9541C11.7062 17.0247 11.7062 17.0954 11.7062 17.2367V26H13.4012C14.2487 26 14.8844 25.364 14.8844 24.5159V19.2155C16.5087 19.4276 17.9212 20.2756 18.5568 21.4064L20.2518 24.4452C20.8168 25.4346 21.8056 26 22.9356 26H24.2068H24.4893H24.913C24.348 25.7173 24.0655 25.364 23.783 24.7279Z",
    fill: "#26354D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKshemaLogo);
export default __webpack_public_path__ + "static/media/KshemaLogo.855b1220b1dc76f9fb6e024e5c5c7b7b.svg";
export { ForwardRef as ReactComponent };